interface Props {
    className?: string;
}

export function MedicalExpensesInsuranceIcon({ className }: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
            <g fill="none" stroke="currentColor" strokeMiterlimit={10} strokeWidth={2.83}>
                <path d="M16.09,56.8c-.18-1.44-.27-2.91-.27-4.39,0-19.73,15.99-35.72,35.72-35.72,13.62,0,25.46,7.62,31.49,18.84" />
                <path d="M87,48.01c.18,1.44.27,2.91.27,4.39,0,19.73-15.99,35.72-35.72,35.72-13.62,0-25.46-7.62-31.49-18.84" />
                <polyline points="82.51 51.77 87 47.28 91.48 51.77" />
                <polyline points="20.72 53.42 16.23 57.91 11.75 53.42" />
            </g>

            <g stroke="currentColor" strokeMiterlimit={10} strokeWidth={0.71}>
                <path
                    d="M70.97,51.96v-3.92c0-1.92-1.56-3.48-3.48-3.48h-8.08v-8.08c0-1.92-1.56-3.48-3.48-3.48h-8.73c-1.92,0-3.48,1.56-3.48,3.48v8.08h-8.01c-1.92,0-3.48,1.56-3.48,3.48v8.73c0,1.92,1.56,3.48,3.48,3.48h8.01v8.08c0,1.92,1.56,3.48,3.48,3.48h8.73c1.92,0,3.48-1.56,3.48-3.48v-8.08h8.08c1.92,0,3.48-1.56,3.48-3.48l-1.59-.03v.03c0,1.01-.82,1.83-1.83,1.83h-8.9c-.46,0-.83.37-.83.83v8.9c0,1.01-.82,1.83-1.83,1.83h-8.73c-1.01,0-1.83-.82-1.83-1.83v-8.9c0-.46-.37-.83-.83-.83h-8.83c-1.01,0-1.83-.82-1.83-1.83v-8.73c0-1.01.82-1.83,1.83-1.83h8.83c.46,0,.83-.37.83-.83v-8.9c0-1.01.82-1.83,1.83-1.83h8.73c1.01,0,1.83.82,1.83,1.83v8.9c0,.46.37.83.83.83h8.9c1.01,0,1.83.82,1.83,1.83v3.93h1.59Z"
                    fill="currentColor"
                />
                <path d="M70.98,56.82c0,.43-.36.77-.8.77s-.8-.35-.8-.77.36-.77.8-.77.8.35.8.77" fill="currentColor" />
                <path d="M70.98,51.94c0,.43-.36.77-.8.77s-.8-.35-.8-.77.36-.77.8-.77.8.35.8.77" fill="currentColor" />
            </g>
        </svg>
    );
}
